module.exports = __webpack_public_path__ + "static/media/banner_01_lg.d8df24a2.jpg";